// Add support for IE 9, 10, 11
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// Requires a DOMRef link to be passed in
// To accomodate Rails integration which prevents a DOMRef being set at application root
function addNotification(DOMRef, title = null, message = null, type = null) {
  const typeWhitelist = ['default', 'success', 'info', 'danger', 'warning'];
  DOMRef.addNotification({
    title: title || 'New Notification',
    message: message || 'Input values are incorrect.',
    type: typeWhitelist.includes(type) ? type : 'default',
    insert: 'top',
    container: 'top-right',
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    dismiss: { duration: 10000 },
    dismissable: { click: true },
  });
}

export function addValidationPassedNotification(DOMRef, message = null) {
  addNotification(DOMRef, 'Form Submitted', message, 'success');
}

export function addValidationFailedNotification(DOMRef, message = null) {
  addNotification(DOMRef, 'Validation Error', message, 'danger');
}

export function addRetranscodeRequestSubmittedNotification(DOMRef) {
  addNotification(
    DOMRef,
    'Retranscode request submitted',
    'Processing may take a couple of minutes. A page refresh is also required to update table data.',
    'success',
  );
}

export default addNotification;
